import { WORLD_H } from './level';
export const GRAVITY = -9.8;
export const CANDY_R = 0.045 * WORLD_H;
export const STAR_R = 0.035 * WORLD_H;
export const OMNOM_R = 0.06 * WORLD_H;
export const BUBBLE_R = 0.05 * WORLD_H;
export const SPIKE_T = 0.02 * WORLD_H;
export const CUSHION = { w: 0.06 * WORLD_H, h: 0.03 * WORLD_H, range: 0.4 * WORLD_H, impulse: 6 };
export const BUOYANCY = 1.6; // 거품: 중력의 배수(위로)
export const CUT_TOL = 0.012 * WORLD_H; // 자르기 판정 여유(밧줄 두께)
export const STEP_DT = 1 / 60;
export const OUT_MARGIN = 0.1 * WORLD_H;
